import MarkdownText from '@/components/markdown/markdown-text';
import NavigationButton from '@/components/navigation/navigation-button';
import { Box, Text } from '@cmpsr/components';
import { ForwardedRef, forwardRef } from 'react';
import { VARS } from '../../../common/constants';
import { text } from '../../../common/theme';
import MembershipBenefits from '../../../shared/MembershipBenefits';

interface MainCTAProps {
  ctaLink: string;
}

export const CTA_TEXT = `Become a Catch member`;

const MainCTA = forwardRef(({ ctaLink }: MainCTAProps, ref: ForwardedRef<HTMLButtonElement>) => {
  return (
    <Box
      data-testid="main-cta"
      borderRadius="radii-4"
      border={`1px solid`}
      background="white"
      display="flex"
      width="100%"
      padding={{ base: 'spacer-5', lg: 'spacer-8' }}
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      gap={{ base: 'spacer-5', lg: 'spacer-6' }}
    >
      <Text as="h3" {...text.mobile.h3} fontWeight={700}>
        What's next?{' '}
      </Text>
      <MarkdownText textAlign="center" {...text.body.regular}>
        Join Catch for $5/month to reduce your risk __**by up to 60%**__.
      </MarkdownText>

      <Box display="flex" flexDirection="column" alignItems="flex-start" gap="spacer-2">
        <MembershipBenefits />
      </Box>
      <Box display="flex" flexDirection="column" alignItems="center" gap="spacer-0">
        <Text {...text.body.copySemiBold}>Only {VARS.price.monthly}/month, billed annually.</Text>
        <Text {...text.body.copySemiBold}>Cancel anytime.</Text>
      </Box>
      <NavigationButton
        ref={ref}
        to={ctaLink}
        display="flex"
        paddingX={{ base: 'spacer-2', lg: 'spacer-6' }}
        paddingY={{ base: 'spacer-4', lg: 'spacer-4' }}
        justifyContent="center"
        alignItems="flex-start"
        gap="spacer-2"
        flex="1 0 0"
        borderRadius="radii-button"
        background="green"
        alignSelf="stretch"
      >
        <Text variant="text-body-medium">{CTA_TEXT}</Text>
      </NavigationButton>
    </Box>
  );
});

MainCTA.displayName = 'MainCTA';

export default MainCTA;
